//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ManningFetalBiophysica_MonitoringScoreAndProcessingPrinciples",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "2", name: "有≥2次胎动，FHR加速，振幅≥15bpm，持续≥15秒" },
        { value: "0", name: "<2次胎动，FHR加速，振幅<15bpm，持续<15秒" },
      ],
      dataList1: [
      { value: "2", name: "≥1次，持续≥30秒" },
      { value: "0", name: "无或持续＜30秒" },
      ],
      dataList2: [
        { value: "2", name: "≥3次躯干和肢体活动（连续出现计1次）" },
        { value: "0", name: "≤2次躯干和肢体活动（连续出现计1次）" },
      ],
      dataList3: [
      { value: "2", name: "≥1次躯干伸展后恢复到屈曲，手指摊开合拢" },
      { value: "0", name: "无活动，肢体完全伸展，伸展缓慢，部分恢复到屈曲" },
      ],
      dataList4: [
        { value: "2", name: "≥1个羊水暗区，最大羊水池垂直直径≥2cm" },
        { value: "0", name: "无或最大羊水池垂直直径＜2cm" },
      ],

    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ManningFetalBiophysica_MonitoringScoreAndProcessingPrinciples.vue